"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.getAdditionalSelectableCardProps = getAdditionalSelectableCardProps;
var _mui = require("@ori-ui/mui");
var _jsxRuntime = require("react/jsx-runtime");
function getAdditionalSelectableCardProps(param) {
    let { isActive, isAlignedToTop, hintMessages, isShippingJoker, onShippingOfferBannerClick, shippingOfferBannerText } = param;
    const result = {
        // align button section content to top if required
        ...isAlignedToTop && {
            ButtonComponentProps: {
                contentAlign: 'start'
            }
        },
        // display hint messages for active item
        ...isActive && hintMessages && hintMessages.length > 0 && {
            AlertComponentProps: {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(_jsxRuntime.Fragment, {
                    children: hintMessages.map((message)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)(_mui.Typography, {
                            children: message
                        }, message))
                })
            }
        },
        // display shipping offer for active item
        ...isActive && isShippingJoker && {
            ActionBannerComponentProps: {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(_mui.Typography, {
                    children: shippingOfferBannerText
                }),
                onClick: onShippingOfferBannerClick
            }
        }
    };
    return result;
}
